import { CanActivateFn, Router } from '@angular/router';
import { inject } from "@angular/core";
import { AccountService } from "../services/account.service";
import { catchError, filter, map, of } from "rxjs";

export const authGuard: CanActivateFn = (route, state) => {
  const userService = inject(AccountService);
  const router = inject(Router);

  return userService.user$.pipe(
    filter(user => !!user),
    map(user => {
      if (user) {
        return true;
      } else {
        router.navigate(['/auth'])
        return false;
      }
    }),
    catchError(() => {
      router.navigate(['/auth'])
      return of(false);
    })
  );
};
